import { Home, Building2, Map, LayoutGrid, PenLine } from 'lucide-react';
import { CONTACT } from '@/content';
import { track } from '@/lib/track';
import { scrollToTarget } from '@/lib/scrollTo';

const ITEMS = [
  { id: 'home', label: 'Home', href: '#overview', icon: Home },
  { id: 'explore', label: 'Explore', href: '#explore', icon: Building2 },
  { id: 'plans', label: 'Plans', href: '#plans', icon: LayoutGrid },
  { id: 'location', label: 'Location', href: '#connectivity', icon: Map },
];

const SECTION_ASSET = {
  '#explore': '/assets/ch02-elevation-spread-1600.webp',
  '#plans': '/assets/plan-first.webp',
  '#connectivity': '/assets/map-connectivity.webp',
};

export default function BottomNav({ onEnquire }) {
  const go = (e, href) => {
    e.preventDefault();
    const src = SECTION_ASSET[href];
    if (src) { const im = new Image(); im.src = src; }
    const el = document.querySelector(href);
    if (!el) return;
    track('nav_click', { target: href, placement: 'bottom_nav' });
    scrollToTarget(el, -16);
  };
  return (
    <>
      {/* floating WhatsApp */}
      <a
        data-testid="whatsapp-float-btn"
        href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent('Hi, I’m interested in Codename Metro One, Navade. Please share details.')}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        onClick={() => track('whatsapp_click', { placement: 'float' })}
        className="fixed bottom-[calc(5.4rem+env(safe-area-inset-bottom))] right-4 z-40 flex h-13 w-13 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_28px_-8px_rgba(37,211,102,0.6)] md:bottom-6 md:right-6"
        style={{ height: 52, width: 52 }}
      >
        <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
          <path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.96L2 22l5.2-1.5A9.9 9.9 0 1 0 12.04 2Zm5.77 14.1c-.24.68-1.4 1.3-1.96 1.35-.5.05-1.13.24-3.8-.8-3.2-1.26-5.24-4.53-5.4-4.74-.16-.21-1.3-1.72-1.3-3.28 0-1.56.82-2.33 1.11-2.65.29-.32.64-.4.85-.4h.61c.2 0 .46-.07.72.55.27.63.9 2.18.98 2.34.08.16.13.35.02.56-.1.21-.16.34-.32.53-.16.19-.34.42-.48.56-.16.16-.33.34-.14.66.18.32.82 1.35 1.76 2.19 1.21 1.08 2.23 1.41 2.55 1.57.32.16.5.13.69-.08.19-.21.79-.92 1-1.24.21-.32.42-.27.71-.16.29.1 1.85.87 2.17 1.03.32.16.53.24.61.37.08.14.08.79-.16 1.47Z" />
        </svg>
      </a>

      {/* bottom dock */}
      <nav
        data-testid="mobile-bottom-nav"
        aria-label="Quick actions"
        className="safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-[#E4E6EB] bg-white/95 backdrop-blur-md md:hidden"
      >
        <div className="grid grid-cols-5">
          {ITEMS.map(({ id, label, href, icon: Icon }) => (
            <a
              key={id}
              href={href}
              data-testid={`bottomnav-${id}-btn`}
              onClick={(e) => go(e, href)}
              className="flex min-h-[56px] flex-col items-center justify-center gap-1 text-[10px] font-semibold text-[#404145] transition-colors active:text-[#C92F4B]"
            >
              <Icon size={20} strokeWidth={1.9} />
              {label}
            </a>
          ))}
          <button
            data-testid="bottomnav-enquire-btn"
            onClick={() => { track('book_visit', { placement: 'bottom_nav' }); onEnquire(); }}
            className="flex min-h-[56px] flex-col items-center justify-center gap-1 bg-[#C92F4B] text-[10px] font-bold text-white"
          >
            <PenLine size={20} strokeWidth={1.9} />
            Enquire
          </button>
        </div>
      </nav>
    </>
  );
}
